module.exports = __webpack_public_path__ + "static/img/logo_ave.dcdfe256.png";